import {createSlice} from '@reduxjs/toolkit';
import {fetchConditionList, fetchConditionSelection} from '../actions/ConditionActions';

// ---- import from local actions ----

const ConditionSlice = createSlice({
  name: 'condition',
  initialState: {
    conditionList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    conditionSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchConditionList.pending, (state) => {
        state.conditionList.status = 'loading';
      })
      .addCase(fetchConditionList.fulfilled, (state, action) => {
        state.conditionList.status = 'idle';
        state.conditionList.data = action.payload.result;
      })
      .addCase(fetchConditionList.rejected, (state, action) => {
        state.conditionList.status = 'rejected';
        state.conditionList.error = action.error.message;
      })
      .addCase(fetchConditionSelection.pending, (state) => {
        state.conditionSelection.status = 'loading';
      })
      .addCase(fetchConditionSelection.fulfilled, (state, action) => {
        state.conditionSelection.status = 'idle';
        state.conditionSelection.data = action.payload.result;
      })
      .addCase(fetchConditionSelection.rejected, (state, action) => {
        state.conditionSelection.status = 'rejected';
        state.conditionSelection.error = action.error.message;
      });
  },
});

export default ConditionSlice.reducer;
